export default {
    namespaced: true,
    state: {
        bread_active: null,
        bread_list: null,
    },
    getters: {},
    mutations: {
        SET_DATA(state, data) {
            eval("state." + data.name + " = data.data;");
        }
    },
    actions: {

    }
}
